const configs = {
  REACT_APP_WS_KEY: 'ebram',
  REACT_APP_WS_HOST: window.location.hostname,
  REACT_APP_WS_PORT: 443,
  REACT_APP_WS_END_POINT: `${window.location.origin}/api/broadcasting/auth`,
};

export default configs;